import { CircularProgress, Grid, makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import BaseWidget from '../BaseWidget'
import PatientsListSkeleton from './PatientsListSkeleton'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '98.5%',
    paddingBottom: 0
  },
  emptyStateContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '98.5%',
    paddingBottom: 0
  },
  header: {
    flexShrink: 0,
    padding: 20,
    borderBottom: '1px solid #E9E9E9'
  },
  patientsList: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    transition: 'opacity 0.3s ease-in-out',
    opacity: 1,
    '&.fading': {
      opacity: 0.5
    }
  },
  patientItem: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 90,
    alignItems: 'center',
    borderBottom: '1px solid #E9E9E9',
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  emptyPatientsList: {
    justifyContent: 'center'
  }
}))

const PatientsList = ({
  isEmpty,
  fetchNextPage,
  hasMorePages,
  patients = [],
  isHeaderLoading,
  isListLoading,
  scoreOptions,
  EmptyStateComponent,
  HeaderSkeletonComponent,
  PatientsHeaderComponent,
  PatientListItemComponent
}) => {
  const classes = useStyles()
  const [isFading, setIsFading] = useState(false)

  useEffect(() => {
    setIsFading(true)
    const timeout = setTimeout(() => setIsFading(false), 300)
    return () => clearTimeout(timeout)
  }, [patients])

  return (
    <BaseWidget className={classes.root} carousel={false}>
      <Grid item className={classes.header}>
        {isHeaderLoading ? HeaderSkeletonComponent : PatientsHeaderComponent}
      </Grid>
      <Grid
        item
        className={`${classes.patientsList} ${isFading ? 'fading' : ''} grin-patients-infinite-scroll ${
          isEmpty ? classes.emptyPatientsList : ''
        }`}
        id="copilot-patients-list"
      >
        {isListLoading ? (
          <PatientsListSkeleton />
        ) : patients.length === 0 ? (
          EmptyStateComponent
        ) : (
          <InfiniteScroll
            style={{ overflow: 'hidden' }}
            dataLength={patients.length}
            scrollableTarget="copilot-patients-list"
            next={fetchNextPage}
            hasMore={hasMorePages}
            loader={
              <div className={classes.loaderContainer}>
                <CircularProgress size={12} style={{ color: 'var(--text-color-25)' }} />
              </div>
            }
          >
            {patients.map((patient, index) =>
              React.createElement(PatientListItemComponent, { patient, scoreOptions, index })
            )}
          </InfiniteScroll>
        )}
      </Grid>
    </BaseWidget>
  )
}

export default PatientsList
